export default __webpack_public_path__ + "static/media/notebook_form.d44fafbb.jpg";